import React, { useCallback, useEffect, useState } from "react";
import {
  Select,
  Form,
  Button,
  Table,
  Input,
  Pagination,
  message,
  Space,
  Modal,
  Radio,
  InputNumber,
  Upload,
} from "antd";
import { SearchOutlined, RedoOutlined } from "@ant-design/icons";
import {
  getLevelList,
  getPublishNews,
  setNewsShelf,
  uploadFile,
  setSortEdit,
  queryAddNewsClickNums,
} from "@root/common/service";
import type { ColumnsType } from "antd/es/table";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { postLeaveAdvertisementTimeMap } from "@root/common/utils";

interface DataType {
  key: number | string;
  orgName: string;
  title: string;
  firstColumnName: string;
  secondColumnName: string;
  selfSortNum: number | string;
  baseNewsType: string;
  publishTime: string;
  removalTime: string;
  publishStatus: string;
  baseNewsRecommend: string;
  author: string;
  updateTime: string;
  topStatus: string;
}
const { Option } = Select;

function Index() {
  const columns: ColumnsType<DataType> = [
    {
      title: "新闻来源",
      dataIndex: "orgName",
      key: "orgName",
    },
    {
      title: "新闻标题",
      dataIndex: "title",
      key: "title",
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      render: (_, e) => <a onClick={() => look(e)}>{e.title}</a>,
    },
    {
      title: "一级栏目",
      dataIndex: "firstColumnName",
      key: "firstColumnName",
    },
    {
      title: "二级栏目",
      dataIndex: "secondColumnName",
      key: "secondColumnName",
    },
    {
      title: "排序",
      dataIndex: "selfSortNum",
      key: "selfSortNum",
    },
    {
      title: "新闻类型",
      dataIndex: "baseNewsType",
      key: "baseNewsType",
      render: (_, a) => (
        <>
          {(() => {
            if (a.baseNewsType == "CONTENT") {
              return "内容";
            } else if (a.baseNewsType == "LINK") {
              return "链接";
            }
          })()}
        </>
      ),
    },
    {
      title: "上架时间",
      dataIndex: "publishTime",
      key: "publishTime",
    },
    {
      title: "下架时间",
      dataIndex: "removalTime",
      key: "removalTime",
    },
    {
      title: "发布状态",
      dataIndex: "publishStatus",
      key: "publishStatus",
      render: (_, a) => (
        <>
          {(() => {
            if (a.publishStatus == "Y") {
              return "发布";
            } else {
              return "未发布";
            }
          })()}
        </>
      ),
    },
    {
      title: "推荐位",
      dataIndex: "baseNewsRecommend",
      key: "baseNewsRecommend",
      render: (_, a) => (
        <>
          {(() => {
            if (a.baseNewsRecommend == "COLUMN") {
              return "栏目";
            } else if (a.baseNewsRecommend == "RECOMMENDED") {
              return "大标题";
            } else {
              return a.baseNewsRecommend;
            }
          })()}
        </>
      ),
    },
    {
      title: "作者",
      dataIndex: "author",
      key: "author",
    },
    {
      title: "最后一次操作时间",
      dataIndex: "updateTime",
      key: "updateTime",
    },
    {
      title: "操作",
      dataIndex: "set",
      key: "set",
      render: (_, e) => (
        <Space size="middle">
          <Button
            style={{ padding: "0" }}
            onClick={() => newsSort(e)}
            type="link"
          >
            新闻排序
          </Button>
          {/* <Button disabled={e.topStatus=='Y'} style={{padding: '0'}} onClick={()=>toTop('Y')} type="link">置顶</Button>
          <Button disabled={e.topStatus=='N'} style={{padding: '0'}} onClick={()=>toTop('N')} type="link">取消置顶</Button> */}
        </Space>
      ),
    },
  ];

  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [firstLevelList, setFirstLevelList] = useState<any>([]);
  const [secondLevelList, setSecondLevelList] = useState<any>([]);
  const [columnList, setColumnList] = useState<any>([]);
  const [current, setCurrent] = useState(1);
  const [data, setData] = useState<DataType[]>();
  const [total, setTotal] = useState<number>(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editItem, setEditItem] = useState<any>({});
  const [isRecommend, setIsRecommend] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [imgUrl, setImgUrl] = useState<any>("");
  const [Options, setOptions] = useState<any>([]);
  const navigate = useNavigate();

  useEffect(() => {
    column();
    column1();
    getTableData();
  }, []);

  const getTableData = async (e: string = "", current = 1) => {
    setCurrent(current);
    setSelectedRowKeys([]);
    const { rows = [], total } = await getPublishNews(
      `${e}newsOperateEnum=ALL&pageNum=${current}&pageSize=10`
    );
    rows.forEach((e: any) => {
      e.key = e.newsId;
      e.publishTime = e.publishTime
        ? moment(e.publishTime).format("YYYY-MM-DD hh:mm:ss")
        : "--";
      e.removalTime = e.removalTime
        ? moment(e.removalTime).format("YYYY-MM-DD hh:mm:ss")
        : "--";
      e.updateTime = e.updateTime
        ? moment(e.updateTime).format("YYYY-MM-DD hh:mm:ss")
        : "--";
    });
    console.log(rows);
    setData(rows);
    setTotal(total);
  };

  const column = async () => {
    const { rows } = await getLevelList(
      `baseNewsColumnLevel=2&pageNum=1&pageSize=99`
    );
    // setColumnList(rows);
    setSecondLevelList(rows);
    return rows;
  };

  const column1 = async () => {
    const { rows } = await getLevelList(
      `baseNewsColumnLevel=1&pageNum=1&pageSize=99`
    );
    setFirstLevelList(
      rows.filter(
        (item: any) => item.name !== "首页" && item.name !== "个人中心"
      )
    );
  };

  const onFinish = useCallback((e: any) => {
    const keys: Array<string> = Object.keys(e);
    const values = Object.values(e);
    const str: string = values.reduce(function (r: string, el, i) {
      if (!!el) {
        r += `${keys[i]}=${el}&`;
      }
      return r;
    }, "");
    getTableData(str);
  }, []);

  const onFinishFailed = useCallback((e: any) => {
    console.log(e);
  }, []);

  const onReset = useCallback(() => {
    form1.resetFields();
    getTableData();
  }, [form1]);

  // const Options = columnList.map((e: any) => {
  //   return <Option value={e.id}>{e.name}</Option>
  // });
  const look = (e: any) => {
    var startTime = new Date().valueOf() / 1000;
    let newsList = [
      {
        id: e.newsId,
        title: e.title,
      },
    ];
    postLeaveAdvertisementTimeMap(newsList, startTime, newsList.length, 2, 2);
    navigate(`/news/details/${e.newsId}`);
  };

  useEffect(() => {
    const opts = columnList.map((e: any) => {
      return (
        <Option value={e.id} key={e.id}>
          {e.name}
        </Option>
      );
    });
    setOptions(opts);
  }, [columnList]);

  const Options1 = firstLevelList.map((e: any) => {
    return (
      <Option value={e.id} key={e.id}>
        {e.name}
      </Option>
    );
  });

  const Options2 = secondLevelList.map((e: any) => {
    return (
      <Option value={e.id} key={e.id}>
        {e.name}
      </Option>
    );
  });

  const handleChange = useCallback(
    (e: any, a: any) => {
      form2.setFieldsValue({ secondColumn: "" });
      console.log("选择结果", e, a);
      const opt = secondLevelList.filter((el: any) => {
        return el.parentId === e;
      });
      setColumnList(opt);
    },
    [secondLevelList]
  );

  const onChange = (current: any) => {
    setCurrent(current);
    form1.resetFields();
    getTableData("", current);
  };

  // const toTop = (e: any)=>{
  //   console.log(e);
  // }

  const newsSort = async (e: any) => {
    console.log(e);
    setEditItem(e);
    if (e.isRecommend === "Y") {
      setIsRecommend(false);
    } else {
      setIsRecommend(true);
    }
    setImgUrl(e.newsImage);
    form2.setFieldsValue({
      isRecommend: e.isRecommend,
      firstColumn: e.firstColumnId,
      secondColumn: e.secondColumnId,
      selfSortNum: e.selfSortNum,
      recommendedSortNum: e.recommendedSortNum,
      baseNewsRecommend: e.baseNewsRecommend,
      imageUrl: e.newsImage,
      clickNum: e.clickNum || 0,
    });
    setIsModalOpen(true);
    setIsUpload(e.baseNewsRecommend === "RECOMMENDED");
    const secondLevelList = await column();
    const opt = secondLevelList.filter((el: any) => {
      return el.parentId === e.firstColumnId;
    });
    setColumnList(opt);
    // setOptions(opt);
  };

  const setShelf = async (e: string) => {
    console.log(selectedRowKeys);
    const { code, msg } = await setNewsShelf({
      publishStatus: e,
      ids: selectedRowKeys,
    });
    if (code == 200) {
      message.success(msg);
    } else {
      message.error(msg);
    }
    getTableData();
    form1.resetFields();
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys: React.Key[]) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  const handleCancel = useCallback(() => {
    form2.resetFields();
    setImgUrl("");
    setIsModalOpen(false);
  }, []);

  const handleOk = useCallback(
    async (e: any) => {
      console.log(e);
      const { clickNum } = e;
      const { code, msg } = await setSortEdit({
        ...e,
        id: editItem.newsId,
      });
      if (code == 200) {
        message.success(msg);
        setIsModalOpen(false);
        getTableData();
        form2.resetFields();
        setImgUrl("");
      } else {
        message.error(msg);
      }
      await queryAddNewsClickNums({
        clickNum,
        newId: editItem.newsId,
      });
    },
    [editItem]
  );

  const recommendChange = (e: any) => {
    if (e.target.value == "Y") {
      setIsRecommend(false);
    } else {
      setIsRecommend(true);
    }
  };

  const baseChange = (e: any) => {
    if (e.target.value === "BANNER") {
      setIsUpload(false);
    } else {
      setIsUpload(true);
    }
  };

  const uploadChange = async (data: any) => {
    const { file } = data;

    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/jpg" &&
      file.type !== "image/png"
    ) {
      message.error("请选择正确的文件");
      return false;
    }
    if (file.size / 1024 / 1024 > 1) {
      message.error("请选择正确的文件");
      return false;
    }

    let width = 0;
    let height = 0;

    const checkSize = function () {
      return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = function () {
          resolve({ width: image.width, height: image.height });
        };
      });
    };
    await checkSize()
      .then((res: any) => {
        width = res.width;
        height = res.height;
      })
      .catch((err) => {
        console.log(err);
        message.error("图片解析错误");
      });

    if (width !== 710 || height !== 260) {
      console.log("width--", width, "height--", height);
      message.error("请上传宽710px、高260px的图片");
      return false;
    }

    let formData = new FormData();
    formData.append("file", file);
    formData.append("uploadFileType", "image");
    formData.append("folder", "course");

    uploadFile(formData).then((res) => {
      setImgUrl(res.shortUrl);
      form2.setFieldsValue({ imageUrl: res.shortUrl });
    });
  };

  return (
    <div style={{ padding: "15px", background: "#fff" }}>
      <div className="top">
        <Form
          name="newsList"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="inline"
          form={form1}
        >
          <Form.Item label="新闻标题" name="title">
            <Input placeholder="请输入内容" style={{ width: 180 }} />
          </Form.Item>

          <Form.Item label="新闻来源" name="orgName">
            <Input placeholder="请输入内容" style={{ width: 180 }} />
          </Form.Item>

          <Form.Item label="发布状态" name="publishStatus">
            <Select placeholder="请选择" allowClear style={{ width: 180 }}>
              <Option value="Y">发布</Option>
              <Option value="N">未发布</Option>
            </Select>
          </Form.Item>

          <Form.Item label="栏目名称" name="columnId">
            <Select placeholder="请选择" allowClear style={{ width: 180 }}>
              {Options2}
            </Select>
          </Form.Item>

          <Form.Item label="作者" name="author">
            <Input placeholder="请输入内容" style={{ width: 180 }} />
          </Form.Item>

          <Form.Item style={{ marginLeft: "30px" }}>
            <Button className="searchBtn" type="primary" htmlType="submit">
              <SearchOutlined />
              查询
            </Button>
            <Button
              className="resetBtn"
              type="primary"
              onClick={onReset}
              style={{ marginLeft: "15px" }}
            >
              <RedoOutlined />
              重置
            </Button>
          </Form.Item>
        </Form>
      </div>

      <div className="midBtn">
        {/* <Button type="primary" onClick={()=>newsSort()} >新闻排序</Button> */}
        <Button type="primary" onClick={() => setShelf("Y")}>
          上架
        </Button>
        <Button type="primary" onClick={() => setShelf("N")}>
          下架
        </Button>
      </div>

      <div className="tableBottom">
        <Table
          size="middle"
          pagination={false}
          columns={columns}
          dataSource={data}
          rowSelection={rowSelection}
        />
        <Pagination
          current={current}
          onChange={onChange}
          total={total}
          showSizeChanger={false}
        />
      </div>

      <Modal
        title="新闻排序"
        visible={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
        bodyStyle={{ display: "flex", justifyContent: "center" }}
      >
        <Form
          name="addUser"
          initialValues={{
            clickNum: 0,
          }}
          onFinish={handleOk}
          autoComplete="off"
          form={form2}
        >
          <p>新闻标题：{editItem.title}</p>
          <Form.Item
            style={{ width: "450px" }}
            label="是否需要重点推荐"
            name="isRecommend"
            rules={[{ required: true, message: "不可为空!" }]}
          >
            <Radio.Group onChange={recommendChange}>
              <Radio value="Y">需要</Radio>
              <Radio value="N">不需要</Radio>
            </Radio.Group>
          </Form.Item>

          {isRecommend ? (
            <>
              <Form.Item
                label="一级栏目"
                name="firstColumn"
                rules={[{ required: true, message: "内容类型不可为空!" }]}
              >
                <Select
                  placeholder="请选择"
                  onChange={handleChange}
                  allowClear
                  style={{ width: 180 }}
                >
                  {Options1}
                </Select>
              </Form.Item>
              <Form.Item
                label="二级栏目"
                name="secondColumn"
                rules={[
                  {
                    required: Options.length !== 0,
                    message: "内容类型不可为空!",
                  },
                ]}
              >
                <Select
                  placeholder="请选择"
                  allowClear
                  style={{ width: 180 }}
                  disabled={Options.length === 0}
                >
                  {Options}
                </Select>
              </Form.Item>
            </>
          ) : (
            <>
              <Form.Item
                label="推荐位置"
                name="baseNewsRecommend"
                rules={[{ required: true, message: "菜单类型不可为空!" }]}
              >
                <Radio.Group onChange={baseChange}>
                  <Radio value="BANNER">banner</Radio>
                  <Radio value="RECOMMENDED">大标题</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label="栏目图片"
                name="imageUrl"
                valuePropName="imageUrl"
                rules={[
                  {
                    required: isUpload ? false : true,
                    message: "图片不可为空!",
                  },
                ]}
              >
                {imgUrl && (
                  <img
                    style={{ width: "328px", height: "216px" }}
                    src={imgUrl}
                    alt=""
                  />
                )}
                <Upload
                  maxCount={1}
                  showUploadList={false}
                  customRequest={uploadChange}
                  disabled={isUpload}
                >
                  <p>* 支持1M以内JPG、PNG，请上传宽710px、高260px的图片</p>
                  <Button disabled={isUpload}>选择文件</Button>
                </Upload>
              </Form.Item>
              <Form.Item
                label="推荐位顺序"
                name="recommendedSortNum"
                rules={[{ required: true, message: "顺序不可为空!" }]}
              >
                <InputNumber min={1} style={{ width: 180 }} />
              </Form.Item>
            </>
          )}

          <Form.Item
            label="排列顺序"
            name="selfSortNum"
            rules={[{ required: true, message: "顺序不可为空!" }]}
          >
            <InputNumber min={1} style={{ width: 180 }} />
          </Form.Item>
          <Form.Item
            label="阅读量"
            name="clickNum"
            rules={[{ required: true, message: "请输入阅读量" }]}
          >
            <InputNumber min={0} style={{ width: 180 }} />
          </Form.Item>
          <Form.Item style={{ display: "flex", justifyContent: "center" }}>
            <Button onClick={handleCancel} style={{ marginRight: "15px" }}>
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              确定
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default Index;
